<template>
  <div>
    <div>
      <span class="xbed-sub-title">清洁账单列表</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>麗家会</BreadcrumbItem>
        <BreadcrumbItem>清洁账单列表</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form inline @submit.native.prevent="preventSubmit" ref="cleanBillListForm" :rules="cleanBillList.rules"
      :model="cleanBillList">
      <Row>
     
        <FormItem label="结算时间：" prop="settlementRange" :label-width="84">
          <DatePicker v-model="cleanBillList.settlementRange"
            @on-change="dateRange => { changeDateRange(dateRange, 'settlementRange') }" :options="disabledDateOptions"
            type="daterange" placeholder="选择日期" style="width: 234px"></DatePicker>
        </FormItem>
        <FormItem label="清洁类型：" prop="cleanTypeId" :label-width="84">
          <Select v-model="cleanBillList.cleanTypeId" filterable>
            <Option value='S00'>全部</Option>
            <Option v-for="(cleanType, index) in cleanTypeList" :key="`${cleanType.id}-${index}`"
              :value="cleanType.id">{{ cleanType.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="付款方：" prop="payerTypeId" :label-width="80">
          <Select v-model="cleanBillList.payerTypeId" filterable>
            <Option value='0'>全部</Option>
            <Option value='1'>Xbed住客</Option>
            <Option value='2'>业主</Option>
            <Option value='3'>第三方</Option>
            <Option value='4'>房东端</Option>
          </Select>
        </FormItem>
        <FormItem label="付款人：" prop="payer" :label-width="80">
          <Input v-model="cleanBillList.payer" placeholder="搜索姓名、手机号"></Input>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="状态：" prop="status" :label-width="80">
          <Select v-model="cleanBillList.status" filterable>
            <Option value="S00">全部</Option>
            <Option value="S01">未结</Option>
            <Option value="S02">完成</Option>
            <Option value="S03">已取消</Option>
          </Select>
        </FormItem>
        <FormItem label="清洁单号：" prop="cleanOrderNo" :label-width="84">
          <Input v-model="cleanBillList.cleanOrderNo" placeholder="搜索清洁单号"></Input>
        </FormItem>
        <FormItem label="订单号：" prop="orderNo" :label-width="80">
          <Input v-model="cleanBillList.orderNo" placeholder="搜索订单号"></Input>
        </FormItem>
        <FormItem label="门店ID：" prop="chainId" :label-width="80">
          <Input v-model="cleanBillList.chainId" placeholder="搜索门店ID"></Input>
        </FormItem>
        <FormItem label="房间ID：" prop="roomId" :label-width="80">
          <Input v-model="cleanBillList.roomId" placeholder="搜索房间ID"></Input>
        </FormItem>
      </Row>
      <Row>
        <FormItem>
          <Button type="primary" @click="queryCleanBillListWithKeyword" :loading="queryBtn">查询</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="exportTable">导出筛选结果</Button>
        </FormItem>
      </Row>
    </Form>
    <Content>
      <Table stripe :loading="cleanBillList.loading" :columns="cleanBillList.columns"
        :data="cleanBillList.data"></Table>
      <div style="margin: 10px; overflow: hidden;">
        <Page show-sizer placement="top" :total="cleanBillList.count" :current="cleanBillList.page"
          :page-size="cleanBillList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
      </div>
    </Content>
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment"
import Utils from "@/utils"
import API from "@/api"
import Config from "@/config"

export default {
  data() {
    const validateOrderList = {
      orderNo: (rule, value, callback) => {
        if (this.cleanBillList.orderNo && isNaN(this.cleanBillList.orderNo)) {
          callback(new Error('请输入正确的清洁单号'))
        } else if (this.cleanBillList.orderNo && this.cleanBillList.orderNo.length > 255) {

          callback(new Error('清洁单号不能超过255字'))
        } else {
          callback()
        }
      },
      xbedOrderNo: (rule, value, callback) => {
        if (this.cleanBillList.xbedOrderNo && isNaN(this.cleanBillList.xbedOrderNo)) {
          callback(new Error('请输入正确的xbed单号'))
        } else if (this.cleanBillList.xbedOrderNo && this.cleanBillList.xbedOrderNo.length > 255) {

          callback(new Error('xbed单号不能超过255字'))
        } else {
          callback()
        }
      },
    }
    return {
      options1: {
        disabledDate(date) {
          // console.log(date,'????')
          const newDate = new Date(), Y = newDate.getMonth() + 1, YY = date.getMonth() + 1
          return YY >= Y
        }
      }, //只能选择小于当月的
      token: '',
      username: '',
      env: '',
      queryBtn: false,
      cleanTypeList: [],
      cleanBillList: {
        settlementRange: [
          moment().subtract(6, 'days').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        cleanTypeId: 'S00',
        payerTypeId: '0',
        payer: '',
        status: 'S00',
        cleanOrderNo: '',
        orderNo: '',
        chainId: '',
        roomId: '',
        columns: [
          {
            title: '清洁单号',
            key: 'cleanOrderNo',
            align: 'center',
            width: 260
          },
          {
            title: '门店ID',
            key: 'chainId',
            align: 'center',
            width: 100
          },
          {
            title: '门店名称',
            key: 'chainName',
            align: 'center',
            width: 150
          },
          {
            title: '房间ID',
            key: 'roomId',
            align: 'center',
            width: 100
          },
          {
            title: '房间名称',
            key: 'roomName',
            align: 'center',
            width: 150
          },
          {
            title: 'xbed订单号',
            key: 'xbedOrderNo',
            align: 'center',
            width: 220
          },
          {
            title: '入住单号',
            key: 'checkInNo',
            align: 'center',
            width: 120
          },
          {
            title: '生成时间',
            key: 'generateDateStr',
            align: 'center',
            width: 260
          },
          {
            title: '结算时间',
            key: 'settlementDateStr',
            align: 'center',
            width: 260
          },
          {
            title: '付款方',
            key: 'payerTypeIdStr',
            align: 'center',
            width: 100
          },
          {
            title: '付款人',
            key: 'payer',
            align: 'center',
            width: 100
          },
          {
            title: '原价',
            key: 'originalMoney',
            align: 'center',
            width: 100
          },
          {
            title: '应付',
            key: 'paymentMoney',
            align: 'center',
            width: 100
          },
          {
            title: '使用优惠',
            key: 'preferentialMoney',
            align: 'center',
            width: 100
          },
          {
            title: '状态',
            key: 'statusStr',
            align: 'center',
            width: 100
          },
          {
            title: '支付单号',
            key: 'payOrderNo',
            align: 'center',
            width: 260
          },
          {
            title: '支付方式',
            key: 'payTypeIdStr',
            align: 'center',
            width: 100
          },
          {
            title: '支付流水号',
            key: 'serialNumber',
            align: 'center',
            width: 260
          },
          {
            title: '清洁类型',
            key: 'cleanTypeName',
            align: 'center',
            width: 260
          },
          {
            title: '管家姓名',
            key: 'cleanerName',
            align: 'center',
            width: 100
          },
          {
            title: '管家薪酬',
            size: 4,
            key: 'housekeeperMoney',
            align: 'center',
            width: 150
          },
          {
            title: '基本薪酬',
            size: 4,
            key: 'basicMoney',
            align: 'center',
            width: 100
          },
          {
            title: '平台补贴',
            size: 4,
            key: 'platformSubsidies',
            align: 'center',
            width: 100
          },
          {
            title: '业主补贴',
            size: 4,
            key: 'hostSubsidies',
            align: 'center',
            width: 100
          },
          {
            title: '福利补贴',
            size: 4,
            key: 'cleanSubsidies',
            align: 'center',
            width: 100
          },
          {
            title: '保险费',
            key: 'insuranceMoney',
            align: 'center',
            width: 120
          },
          {
            title: '业主清洁费',
            key: 'hostCleanFee',
            align: 'center',
            width: 120
          },
          {
            title: '丽家会收入',
            key: 'platformIncome',
            align: 'center',
            width: 120
          },
          {
            title: '巾类洗涤费',
            key: 'towelOwnerCharge',
            align: 'center',
            width: 150
          },
          {
            title: '床品洗涤费',
            key: 'bedspreadOwnerCharge',
            align: 'center',
            width: 150
          },
          {
            title: '易耗品费',
            key: 'consumbleOwnerCharge',
            align: 'center',
            width: 150
          },
          {
            title: '建单原因',
            key: 'orderRemark',
            align: 'center',
            width: 260
          }
        ],
        data: [],
        count: 0,
        page: 1,
        pageSize: 10,
        loading: false,
        rules: {
          cleanOrderNo: [
            { validator: validateOrderList.orderNo, trigger: "blur" }
          ],
          orderNo: [
            { validator: validateOrderList.xbedOrderNo, trigger: "blur" }
          ]
        }
      },
      // 结算时间限制条件
      disabledDateOptions: {
        disabledDate(date) {
          let tomorrow = moment().add(0, 'day').startOf('day').valueOf()
          return date && date.valueOf() > tomorrow
        }
      }
    }
  },

  async created() {
    this.token = Utils.findFromLocalStorage("vue-token")
    this.username = Utils.findFromLocalStorage("vue-username")
    this.env = Utils.findFromLocalStorage("env", "dev")
  },

  async mounted() {

    this.$Notice.config({
      top: 200
    })
    if (!Utils.hasPermission('oms_xbclean_xbCleanBill_list')) {
      this.$Notice.error({
        title: "无权限查看"
      })
      return
    } else {
      this.queryCleanTypeList()
      this.queryCleanBillList()
    }
  },

  methods: {
    async queryCleanTypeList() {
      const params = {
        page: 1,
        pageSize: 999999
      }
      const resp = (await API.omsAPI[this.env].cleaner.queryListForCleanType(params, this.token)).data
      if (resp.retCode) {
        this.$Notice.error({
          title: "查询清洁类型列表失败",
          desc: resp.msg
        })
        return
      }
      this.cleanTypeList = resp.content
    },

    queryCleanBillListWithKeyword() {
      let validResult = false
      this.$refs.cleanBillListForm.validate(valid => {
        validResult = valid
      })
      if (!validResult) {
        return
      }

      this.cleanBillList.page = 1
      this.queryCleanBillList()
    },

    async queryCleanBillList() {
      if (!Utils.hasPermission('oms_xbclean_xbCleanBill_list')) {
        this.$Notice.error({
          title: "无权限操作"
        })
        return
      }
      try {
        this.queryBtn = true
        this.cleanBillList.loading = true
        const resp = (await this.sendCleanBillList(this.cleanBillList, this.token, this.env)).data
        if (resp.retCode) {
          this.$Notice.error({
            title: "查询失败",
            desc: resp.msg
          })
          this.cleanBillList.loading = false
          return
        }
        resp.content.forEach(function (o, i) {
          resp.content[i].generateDateStr = o.generateDate ? moment(o.generateDate).format("YYYY-MM-DD HH:mm:ss") : ""
          resp.content[i].settlementDateStr = o.settlementDate ? moment(o.settlementDate).format("YYYY-MM-DD HH:mm:ss") : ""
          resp.content[i].createDateStr = o.createDate ? moment(o.createDate).format("YYYY-MM-DD HH:mm:ss") : ""
          resp.content[i].updateDateStr = o.updateDate ? moment(o.updateDate).format("YYYY-MM-DD HH:mm:ss") : ""
          resp.content[i].consumableMoney = o.bedspreadOwnerCharge + o.towelOwnerCharge
          resp.content[i].roomName = o.roomId + "_" + o.roomName
          resp.content[i].basicMoney = (o.housekeeperMoney - o.hostSubsidies - o.platformSubsidies - o.cleanSubsidies).toFixed(2)
          resp.content[i].originalMoney = !o.originalMoney ? o.originalMoney : o.originalMoney.toFixed(2)
          resp.content[i].paymentMoney = !o.paymentMoney ? o.paymentMoney : o.paymentMoney.toFixed(2)
          resp.content[i].preferentialMoney = !o.preferentialMoney ? o.preferentialMoney : o.preferentialMoney.toFixed(2)
          resp.content[i].housekeeperMoney = !o.housekeeperMoney ? o.housekeeperMoney : o.housekeeperMoney.toFixed(2)
          resp.content[i].platformSubsidies = !o.platformSubsidies ? o.platformSubsidies : o.platformSubsidies.toFixed(2)
          resp.content[i].hostSubsidies = !o.hostSubsidies ? o.hostSubsidies : o.hostSubsidies.toFixed(2)
          resp.content[i].cleanSubsidies = !o.cleanSubsidies ? o.cleanSubsidies : o.cleanSubsidies.toFixed(2)
          resp.content[i].insuranceMoney = !o.insuranceMoney ? o.insuranceMoney : o.insuranceMoney.toFixed(2)
          resp.content[i].hostCleanFee = !o.hostCleanFee ? o.hostCleanFee : o.hostCleanFee.toFixed(2)
          resp.content[i].platformIncome = !o.platformIncome ? o.platformIncome : o.platformIncome.toFixed(2)
          resp.content[i].towelOwnerCharge = !o.towelOwnerCharge ? o.towelOwnerCharge : o.towelOwnerCharge.toFixed(2)
          resp.content[i].bedspreadOwnerCharge = !o.bedspreadOwnerCharge ? o.bedspreadOwnerCharge : o.bedspreadOwnerCharge.toFixed(2)
          resp.content[i].consumbleOwnerCharge = !o.consumbleOwnerCharge ? o.consumbleOwnerCharge : o.consumbleOwnerCharge.toFixed(2)
          switch (o.payerTypeId) {
            case 1:
              resp.content[i].payerTypeIdStr = "Xbed住客"
              break
            case 2:
              resp.content[i].payerTypeIdStr = "业主"
              break
            case 3:
              resp.content[i].payerTypeIdStr = "第三方"
              break
            case 4:
              resp.content[i].payerTypeIdStr = "房东端"
              break
          }
          switch (o.payTypeId) {
            case 1:
              resp.content[i].payTypeIdStr = "OMS"
              break
            case 2:
              resp.content[i].payTypeIdStr = "微信支付"
              break
            case 3:
              resp.content[i].payTypeIdStr = "银联支付"
              break
          }
          switch (o.status) {
            case 'S01':
              resp.content[i].statusStr = "未结"
              break
            case 'S02':
              resp.content[i].statusStr = "完成"
              break
            case 'S03':
              resp.content[i].statusStr = "已取消"
              break
          }
        })
        this.cleanBillList.data = resp.content
        this.cleanBillList.count = resp.totalCount
        this.cleanBillList.loading = false
        this.queryBtn = false
      } catch (err) {
        console.error(err)
        this.cleanBillList.loading = false
        this.queryBtn = false
      }
    },

    sendCleanBillList(cleanBillList, token, env) {
      let params = {
        page: cleanBillList.page,
        size: cleanBillList.pageSize,
      }
      if (this.cleanBillList.settlementRange.join('').length > 0) {
        params.settlementStartDate = moment(this.cleanBillList.settlementRange[0]).format("YYYY-MM-DD")
        params.settlementEndDate = moment(this.cleanBillList.settlementRange[1]).format("YYYY-MM-DD")
      }

      this.cleanBillList.cleanTypeId !== 'S00' ? params.cleanTypeId = this.cleanBillList.cleanTypeId : ''
      this.cleanBillList.payerTypeId !== '0' ? params.payerTypeId = this.cleanBillList.payerTypeId : ''
      this.cleanBillList.payer ? params.payer = this.cleanBillList.payer : ''
      this.cleanBillList.status !== 'S00' ? params.status = this.cleanBillList.status : ''
      this.cleanBillList.cleanOrderNo ? params.cleanOrderNo = this.cleanBillList.cleanOrderNo : ''
      this.cleanBillList.orderNo ? params.orderNo = this.cleanBillList.orderNo : ''
      this.cleanBillList.chainId ? params.chainId = this.cleanBillList.chainId : ''
      this.cleanBillList.roomId ? params.roomId = this.cleanBillList.roomId : ''
      return API.omsAPI[env].cleaner.cleanBillList(params, token)
    },

    changePage(pageIndex) {
      this.cleanBillList.page = pageIndex
      this.queryCleanBillList()
    },

    changePageSize(pageSize) {
      this.cleanBillList.page = 1
      this.cleanBillList.pageSize = pageSize
      this.queryCleanBillList()
    },

    exportTable() {
      if (!Utils.hasPermission('excel_exportCleanBillList')) {
        this.$Notice.error({
          title: "无权限操作"
        })
        return
      }
      if (!this.cleanBillList.data.length) {
        this.$Notice.error({
          title: "没数据可导"
        })
        return
      }
      let params = {
        settlementStartDate: moment(this.cleanBillList.settlementRange[0]).format("YYYY-MM-DD"),
        settlementEndDate: moment(this.cleanBillList.settlementRange[1]).format("YYYY-MM-DD")
      }
      this.cleanBillList.cleanTypeId !== 'S00' ? params.cleanTypeId = this.cleanBillList.cleanTypeId : ''
      this.cleanBillList.payerTypeId !== '0' ? params.payerTypeId = this.cleanBillList.payerTypeId : ''
      this.cleanBillList.payer ? params.payer = this.cleanBillList.payer : ''
      this.cleanBillList.status !== 'S00' ? params.status = this.cleanBillList.status : ''
      this.cleanBillList.cleanOrderNo ? params.cleanOrderNo = this.cleanBillList.cleanOrderNo : ''
      this.cleanBillList.orderNo ? params.orderNo = this.cleanBillList.orderNo : ''
      this.cleanBillList.chainId ? params.chainId = this.cleanBillList.chainId : ''
      this.cleanBillList.roomId ? params.roomId = this.cleanBillList.roomId : ''
      const initParam = params => {
        let paramStr = ''
        Object.keys(params).forEach(item => {
          if (params[item] !== '') {
            paramStr += item + '=' + params[item] + '&'
          }
        })
        return paramStr.substring(0, paramStr.lastIndexOf('&'))
      }
      let paramStr = initParam(params)
      let url = `${Config[this.env].ljhUrl}admin/xbBillClean/exportBillList?${paramStr}`
      window.open(url, '_blank')
    },
   
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/pages/cleaner/clean-bill-list.vue